/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Tab_Team_QuotasInputs */



/**
* | output |
* | --- |
* | "Team & Quotas" |
*
* @param {Sub_Tab_Team_QuotasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_tab_team_quotas = /** @type {((inputs?: Sub_Tab_Team_QuotasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Tab_Team_QuotasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team & Kontingente")
	return /** @type {LocalizedString} */ ("Team & Quotas")
});